module.exports = __webpack_public_path__ + "static/media/noResultsSmall.17e62bcc.svg";